/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Tabs = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.5 3C20.3284 3 21 3.67157 21 4.5L21 16.5C21 17.3284 20.3284 18 19.5 18L7.5 18C6.67157 18 6 17.3284 6 16.5L6 4.5C6 3.67157 6.67157 3 7.5 3L19.5 3ZM19.5 4.5L7.5 4.5L7.5 16.5L19.5 16.5L19.5 4.5Z"
                        fill={color}
                    />
                    <path
                        d="M4.5 19.5L17 19.5L17 21L4.5 21C3.67157 21 3 20.3284 3 19.5L3 8L4.5 8L4.5 19.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
